import * as Yup from 'yup'

export const settingSchema = Yup.object().shape({
    key: Yup.string().required('Setting Key is required').min(1, 'Setting Key must be at least 1 characters').max(255, 'Setting Key must be at most 255 characters'),
    value: Yup.string().required('Setting Key is required').min(1, 'Setting Key must be at least 1 characters')
})